import Navbar from "@Components/navbar";
import styles from "./styles";
import ContactTable from "./components/ContactTable/ContactTable";
import { DownloadIcon, UploadIcon } from "@radix-ui/react-icons"
import { PlayIcon, TrashPNG } from "@assets/index";
import { useDeleteContactMutation, useUserContactsMutation } from "./apiSlice";
import { useRef, useState, useEffect } from "react";

import ReactModal from 'react-modal';
import ContactEditModal from "./components/ContactEditModal";
import { RootState, useAppSelector } from "@Store/store";

const Contacts = () => {

  const { user } = useAppSelector((state: RootState) => state.profile);
  const selectedIgId = useAppSelector((state: RootState) => state.igSelection.selectedIgId);

  const [getContacts, { data: contactsData, error: contactsErr, isLoading: contactsLoading }] = useUserContactsMutation()
  const [deleteContact, { data: contactDeleteData, error: contactDeleteErr, isLoading: contactDeleteLoading }] = useDeleteContactMutation()


  const [editContactModal, setEditContactModal] = useState(false)
  const [EditContactModalData, setEditContactModalData] = useState({})

  const [deleteContactModal, setDeleteContactModal] = useState(false)
  const [DeleteContactModalData, setDeleteContactModalData] = useState(-1)

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    if (selectedIgId) {
      getContacts({
        ig_id: selectedIgId,
        page: page,
        limit: limit
      });
    }
  }, [page, limit, selectedIgId]);

  useEffect(() => {
    document.title = "LinkPlease - Dashboard | Instagram Contact List";
  }, []);

  useEffect(() => {
    if (contactsData) console.log(contactsData);

    if (contactsErr) console.log(contactsErr)

  }, [contactsData, contactsErr])

  useEffect(() => {
    if (contactDeleteData) {
      getContacts({})
    };

    if (contactDeleteErr) console.error(contactDeleteErr)

  }, [contactDeleteData, contactDeleteErr])


  const closeEditContactModal = () => {
    setEditContactModal(!editContactModal)
  }

  const openEditContactModal = (contact_index: number) => {
    setEditContactModalData(contactsData?.data?.contacts?.[contact_index])
    setEditContactModal(!editContactModal)
  }


  const closeDeleteContactModal = () => {
    setDeleteContactModal(!DeleteContactModal)
  }

  const openDeleteContactModal = (contactmap_id: number) => {
    setDeleteContactModalData(contactmap_id)
    setDeleteContactModal(!editContactModal)
  }

  const deleteContactButtonClick = (e: any) => {
    deleteContact(DeleteContactModalData)
    setDeleteContactModal(!DeleteContactModal)
  }


  return (
    <div className="p-3">

      <div className="flex justify-between bg-white-abs">
        <div className="border-b w-full pb-3 rounded-lg border-gray-200">
          <div className="space-y-2">

            <h1 className="text-2xl md:text-3xl font-medium">Contacts</h1>
            <p>Contact list stores the list of all the Instagram accounts that have interacted with you.</p>

          </div>
        </div>
        {/* <div className="flex items-center justify-center gap-8">
          <div className="flex items-center gap-2">
            <img src={PlayIcon} />
            <p className="text-[#7367F0] font-bold text-[16px]">+Watch Tutorial</p>
          </div>
          <div className="flex flex-col items-center gap-4 relative top-4">
            <button style={styles.ADD_BUTTON}>+ Add Contact</button>
            <p className="text-[12px] text-[#A9A9A9] font-bold">
              (375784 in total)
            </p>
          </div>
        </div> */}
      </div>

      <div className="flex flex-col">
        {/* <div className="flex justify-between p-[2rem] ">
          <div className="flex items-center gap-4">
            <p className="font-bold text-[16px]">Sorted by:</p>
            <div>
              <select
                name=""
                className="py-3 px-4 text-[#808080] rounded-[5px] text-[12px] font-bold border-[0.5px] border-[#A9A9A9]"
              >
                <option>Last Updated</option>
              </select>
            </div>
            <div className="relative">
              <input
                type="text"
                className="py-3 px-4 text-[#808080] rounded-[5px] text-[12px] font-bold border-[0.5px] border-[#A9A9A9] w-[200px] placeholder-[#D3D3D3] placeholder-font-normal" placeholder="Search..."
              />
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "10px",
                  transform: "translateY(-50%)",
                }}
              >
                <svg
                  className="w-4 h-4 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
            </div>
            <div className="p-3 rounded bg-[#22c55e] text-white-abs">
              <MixerHorizontalIcon/>
            </div>
          </div>
          <div className="flex gap-4">
            <div className="flex items-center gap-3 divide-x bg-white-abs rounded-3xl border-2 p-3 divide-slate-400 border-white-abs">
                <div className="flex items-center gap-2 text-[12px]">
                  <UploadIcon />
                  <p>Export</p>
                </div>
                <div className="flex items-center gap-2 text-[12px] pl-2">
                  <DownloadIcon />
                  <p>Import</p>
                </div>
            </div>
            <div className="items-center flex">
              <img src={TrashPNG} />
            </div>
          </div>
        </div>
        */}
        <div className="mt-[3rem]">
          {contactsLoading ? (
            <div className="flex flex-col items-center justify-center p-12 bg-white rounded-lg border border-gray-100">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600 mb-4"></div>
              <p className="text-gray-500 text-sm">Loading contacts...</p>
            </div>
          ) : (
            <ContactTable data={contactsData?.data?.contacts} openEditContactModal={openEditContactModal} openDeleteContactModal={openDeleteContactModal} />
          )}

          {/* Pagination Controls */}
          {!contactsLoading && contactsData?.data?.contacts?.length > 0 && (
            <div className="flex flex-col sm:flex-row items-center justify-between mt-4 px-2 gap-4">
              <div className="flex items-center gap-4 w-full sm:w-auto justify-between sm:justify-start">
                <div className="flex items-center gap-2">
                  <label htmlFor="limit" className="text-sm text-gray-600 whitespace-nowrap">Rows per page:</label>
                  <select
                    id="limit"
                    value={limit}
                    onChange={(e) => {
                      setLimit(Number(e.target.value));
                      setPage(1);
                    }}
                    className="text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 bg-white py-1 pl-2 pr-6"
                  >
                    {[10, 50, 100, 250, 500, 1000].map(val => (
                      <option key={val} value={val}>{val}</option>
                    ))}
                  </select>
                </div>

                <div className="text-sm text-gray-700">
                  <span className="font-semibold">{page}</span> / <span className="font-semibold">{contactsData?.data?.total_pages || 1}</span> <span className="text-gray-500 ml-1 hidden sm:inline">(Total: {contactsData?.data?.total_count || 0})</span>
                </div>
              </div>

              <div className="flex items-center space-x-2 w-full sm:w-auto justify-end">
                {contactsLoading && (
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-indigo-600 mr-2"></div>
                )}
                <button
                  onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                  disabled={page === 1 || contactsLoading}
                  className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${page === 1 || contactsLoading
                    ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                    : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 shadow-sm"
                    }`}
                >
                  Previous
                </button>
                <button
                  onClick={() => setPage((prev) => prev + 1)}
                  disabled={page >= (contactsData?.data?.total_pages || 1) || contactsLoading}
                  className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${page >= (contactsData?.data?.total_pages || 1) || contactsLoading
                    ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                    : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 shadow-sm"
                    }`}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <EditContactModal data={EditContactModalData} isModalOpen={editContactModal} editContactModalOnClose={closeEditContactModal} />
      <DeleteContactModal isModalOpen={deleteContactModal} editContactModalOnClose={closeDeleteContactModal} deleteContact={deleteContactButtonClick} />
    </div>
  );
};



interface EditContactModalInterface {
  isModalOpen: boolean;
  data: any
  editContactModalOnClose: () => void;
}


const EditContactModal = (props: EditContactModalInterface) => {

  return (
    <ReactModal
      isOpen={props.isModalOpen}
      onRequestClose={props.editContactModalOnClose}
      style={
        { overlay: {}, content: styles.editContactModalContent }
      }
      portalClassName={"ReactModalPortal"}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      role={"dialog"}
      preventScroll={false} >
      <ContactEditModal data={props?.data} onCloseModal={props.editContactModalOnClose} />
    </ReactModal>
  )
}



interface DeleteContactModalInterface {
  isModalOpen: boolean;
  editContactModalOnClose: () => void;
  deleteContact: (e: any) => void;
}


const DeleteContactModal = (props: DeleteContactModalInterface) => {

  return (
    <ReactModal
      isOpen={props.isModalOpen}
      onRequestClose={props.editContactModalOnClose}
      style={
        { overlay: {}, content: styles.deleteContactModalContent }
      }
      portalClassName={"ReactModalPortal"}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      role={"dialog"}
      preventScroll={false}
    >
      <>
        <div className="pb-[.5rem] border-b-2 border-slate-300" style={styles.modalHeader}>
          <h3>Confirm</h3>
        </div>
        <div className="py-[1rem]" style={styles.modalContent}>
          <p>Do you want to remove this contact?</p>
          <div className="flex justify-end mt-[2rem]">
            <button
              className="px-6 py-1 border-2 border-solid rounded border-green-500 mx-2"
              style={styles.greenButton}
              onClick={props.editContactModalOnClose}>
              Cancel
            </button>
            <button className="px-6 py-1 border-2 border-solid rounded" style={styles.redButton} onClick={props.deleteContact}>Delete</button>
          </div>
        </div>
      </>
    </ReactModal>
  )
}



export default Contacts;
